import styled from "styled-components";

export const Center = styled("div")`
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 18px;
  line-height: 22px;
`;
